
import React from 'react';
import { AlertCircle } from 'lucide-react';

const WaterIssuesKpi = () => {
  return (
    <div className="h-full flex items-center justify-center">
      <div className="p-4 flex flex-col items-center justify-center h-full w-full">
        <h3 className="text-lg font-medium text-gray-800 dark:text-white mb-2">Issues</h3>
        <div className="mb-2">
          <AlertCircle className="h-7 w-7 text-blue-500 mb-2" />
        </div>
        <div className="flex gap-3 text-xl font-bold mb-2">
          <span className="text-red-500">0</span>
          <span className="text-yellow-500">2</span>
        </div>
        <p className="text-xs text-gray-500 dark:text-gray-300">Critical / Warning</p>
      </div>
    </div>
  );
};

export default WaterIssuesKpi;
